import { BottomNav } from './BottomNav';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { ConsentGate } from './ConsentGate';
import { Lock } from 'lucide-react';

function AccessExpiredScreen() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6" data-testid="access-expired-screen">
      <div className="w-20 h-20 rounded-3xl flex items-center justify-center mb-6 bg-[#FF5C5C]/15">
        <Lock className="w-9 h-9 text-[#FF5C5C]" strokeWidth={2.2} />
      </div>
      <h2 className="font-display font-black text-2xl">Your access has expired</h2>
      <p className="text-sm text-muted-foreground mt-3 max-w-sm leading-relaxed">
        Your YourReGen access period has ended. Please contact your coach to renew your access and continue your program.
      </p>
      <button onClick={logout} data-testid="access-expired-logout" className="mt-6 text-sm text-[#00C8FF] hover:underline">Log out</button>
    </div>
  );
}

export function ClientShell() {
  const loc = useLocation();
  const { user } = useAuth();
  // Unfinished onboarding always resumes in the sign-up flow (answers are restored from the saved draft).
  if (user?.role === 'client' && user?.onboarding_completed === false) {
    return <Navigate to="/register" replace />;
  }
  // No tier chosen yet → either resume checkout (onboarded, paid plan pending) or the journey picker.
  if (user?.role === 'client' && !user?.subscription_tier) {
    if (user?.onboarding_completed && user?.pending_plan) {
      const q = user.pending_plan === 'regen_plus'
        ? `plan=plus&billing=${user.pending_billing || 'annual'}`
        : `plan=protocol&billing=${user.pending_billing || '12'}`;
      return <Navigate to={`/checkout?${q}`} replace />;
    }
    return <Navigate to="/choose-journey" replace />;
  }
  // Access-code entitlement window has passed → lock the whole client app.
  if (user?.role === 'client' && user?.access_expired) {
    return <AccessExpiredScreen />;
  }
  const isFullBleed = loc.pathname === '/app/coach';
  // Root cause of the phone-sized desktop app: every page sat inside one max-w-2xl (672px) column.
  // Desktop now gets a sidebar offset and a wide container; pages lay out with lg: grids.
  return (
    <ConsentGate>
      <div className={`min-h-screen lg:pl-60 ${isFullBleed ? '' : 'pb-24 lg:pb-10'}`} data-testid="client-shell">
        <main className={isFullBleed ? '' : 'app-desktop max-w-2xl mx-auto px-4 pt-6 pb-6 lg:max-w-6xl lg:px-10 lg:pt-10 animate-fade-up'}>
          <Outlet />
        </main>
        {isFullBleed ? <div className="hidden lg:block"><BottomNav /></div> : <BottomNav />}
      </div>
    </ConsentGate>
  );
}
